
import TableTextInput from './TableTextInput'
import TableDateInput from './TableDateInput'

import TableImageInput from './TableImageInput'
import TabelGlobalUserInput from './TabelGlobalUserInput'
import TablePhoneInput from './TablePhoneInput'
import TableMultiSelectInput from './TableMultiSelectInput'
import TableStatusIndicator from './TableStatusIndicator'
import TableSelectInput from './TableSelectInput'
import TableMultiLevelSelect from './TableMultiLevelSelect'
import TablePriceInput from './TablePriceInput'
import TableStatusSelectInput from './TableStatusSelectInput'
import TabelGlobalUserMultiInput from './TabelGlobalUserMultiInput'
import TableTimeInput from './TableTimeInput'
import TableLookupInput from './TableLookupInput'
import TableStageInput from './TableStageInput'
import TableDateTimeInput from './TableDateTimeInput'
import TableQuestionInput from './TableQuestionInput'
import TableTextEditorInput from './TableTextEditorInput'
import TableTextAreaInput from './TableTextAreaInput'
import ButtonInput from './ButtonInput'
import NumberInput from '../inputs/NumberInput'
import TableDurationInput from './TableDurationInput'
import TableVideoInput from './TableVideoInput'
import TableSwitchInput from './TableSwitchInput'
import TableRegionsInput from './TableRegionsInput'
import TableLicenseInput from './TableLicenseInput'
import TableDynamicInput from './TableDynamicInput'


const inputComponents = {
    // PhoneInput:TableTextInput,
    CalendarInput: TableSelectInput,
    NumberInput: TableTextInput,
    PasswordInput: TableTextInput,
    CodeGeneratorInput: TableTextInput,
    TextInput: TableTextInput,
    SelectInput: TableSelectInput,
    ImageSelectInput: TableSelectInput,

    TextAreaInput: TableTextAreaInput,
    SwitchInput: TableSwitchInput,
    // ProfileImageInput:TableTextInput,
    SelectListInput: TableTextInput,
    CheckboxInput: TableTextInput,
    FromToInput: TableTextInput,
    PriceInput: TablePriceInput,
    SliderInput: TableTextInput,
    AdvancedSelectInput: TableSelectInput,
    MultiSelectInput: TableMultiSelectInput,
    ImageInput: TableImageInput,
    ProfileImageInput: TableImageInput,
    ProfileImageRowInput: TableImageInput,
    StatusSelectInput: TableStatusSelectInput,
    DateInput: TableDateInput,
    GlobalUserInput: TabelGlobalUserInput,
    GlobalUserMultiInput: TabelGlobalUserMultiInput,
    PhoneInput: TablePhoneInput,
    StatusInput: TableStatusIndicator,
    HubStatusIndicator: TableStatusIndicator,
    MultiLevelSelect: TableMultiLevelSelect,
    CategorizerInput: TableMultiSelectInput,
    GroupsSelectInput: TableMultiSelectInput,
    TimeInput: TableTimeInput,
    LookupInput: TableLookupInput,
    StageInput: TableStageInput,
    DateTimeInput: TableDateTimeInput,
    QuestionInput: TableQuestionInput,
    TextEditorInput: TableTextEditorInput,
    ButtonInput: ButtonInput,
    DurationInput: TableDurationInput,
    VideoInput: TableVideoInput,
    RegionsInput: TableRegionsInput,
    LicenseInput: TableLicenseInput,
    DynamicInput: TableDynamicInput


}

export default (inputComponents);